import { useReselector } from '@/utils/sharedHooks'
import { getTransactionCategorySelector } from '@/features/reports/reports.selectors'
import { Text, Separator } from '@/ui'
import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { TextColors } from '@/styles'

export const LineItem = ({
  item,
}: {
  item: {
    sum: number | string
    transactionCategoryId: number | null
  }
}) => {
  const category = useReselector(
    getTransactionCategorySelector,
    item.transactionCategoryId
  )

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-2 border-b border-neutral-200">
      <Text className="sm:w-2/3">{category?.name || 'To Be Categorized'}</Text>
      <Text className="sm:w-1/3 text-right sm:text-right mt-2 sm:mt-0">
        <CurrencyFormatLabel value={item?.sum} />
      </Text>
    </div>
  )
}

export const TotalLineItem = ({
  label,
  sum,
}: {
  label: string
  sum: string | number
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center py-2">
      <Text className="sm:w-1/4">{label}</Text>

      <Separator className="hidden sm:block sm:w-7/12" />

      <Text
        className="sm:w-1/6 text-right mt-2 sm:mt-0"
        color={TextColors.GREEN}
      >
        <CurrencyFormatLabel value={sum} />
      </Text>
    </div>
  )
}
